<template>
  <a-modal
    title="打印送货单"
    width="1200px"
    :visible="visible"
    :confirmLoading="confirmLoading"
    cancelText="关闭"
    @cancel="handleCancel"
    wrapClassName="ant-modal-cust-warp"
    style="top:30%;height: 55%;overflow-y: hidden">
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button  v-print="'#print'" ghost type="primary">打印送货单</a-button>
    </template>
    <div id="print">
      <div style="text-align: center;">
        <h1>送货单</h1>
      </div>
      <a-descriptions title="" bordered>
        <a-descriptions-item label="客户名称">
          {{data.organName}}
        </a-descriptions-item>
        <a-descriptions-item label="联系人">
          {{data.contacts}}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话">
          {{data.phoneNum}}
        </a-descriptions-item>
        <a-descriptions-item label="客户地址">
          {{data.address}}
        </a-descriptions-item>
        <a-descriptions-item label="销售订单编号">
          {{data.linkHeadNumber}}
        </a-descriptions-item>
        <a-descriptions-item label="发货时间">
          {{data.deliveryTime}}
        </a-descriptions-item>
      </a-descriptions>

      <div class="ant-descriptions-title"   style="margin-top: 20px ">发货清单</div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns1"
        :dataSource="dataSource1"
        :pagination="false"
      >
      </a-table>
      <a-descriptions
        title=""
        style="margin-top: 20px"
      >
        <a-descriptions-item label="制单人">
          {{data.preparer}}
        </a-descriptions-item>
        <a-descriptions-item label="配货人">
          {{data.distributor}}
        </a-descriptions-item>
        <a-descriptions-item label="客户签收">
        </a-descriptions-item>
      </a-descriptions>
    </div>

  </a-modal>

</template>
<script>
import { Logistics } from '@api/logistics'
export default {
  name: "LogisticsDetailPrintModal",
  mixins: [],
  components: {},
  data() {
    return {
      confirmLoading:false,
      visible: false,
      data:{},
      dataSource1:[],
      // 表头
      columns1: [
        { title: '序号', dataIndex: '', key: 'rowIndex', width: 50, align: "center", customRender: function (t, r, index) {return parseInt(index) + 1;}},
        { title: '条码', dataIndex: 'barCode',align: "center",width:120, ellipsis:true},
        { title: '名称', dataIndex: 'name',align: "center",width:120, ellipsis:true},
        { title: '规格', dataIndex: 'standard',align: "center",width:120, ellipsis:true},
        { title: '单位', dataIndex: 'unit',align: "center",width:120, ellipsis:true},
        { title: '数量', dataIndex: 'operNumber',align: "center",width:120, ellipsis:true},
        { title: '备注', dataIndex: 'remark',align: "center",width:120, ellipsis:true}
      ],
      labelCol: {},
      wrapperCol: {},
      cardStyle: '',
    }
  },
  methods: {
    handleOk(){
      this.handleCancel()
    },
    handleCancel(){
      this.visible = false
    },
    show(record){
      this.visible = true
      Logistics.detail(record.id).then(res => {
        let values = res.data
        this.data = values
        this.dataSource = values.items
        return values
      }).then( values => {
        Logistics.headItems({headerId: values.linkHeadId}).then(res => {
          this.dataSource1 = res.data.rows
        })
      })
    },
  }
}

</script>